import '@material/mwc-button';
import '@material/mwc-top-app-bar-fixed';
import { html } from 'lit-html';
import { routes } from '../../../bootstrap.routes';
import { BaseElement } from '../../utilities/base-element';
import styles from './header.module.scss';

const tag = 'header-element';

class HeaderElement extends BaseElement {

  createNavLink(slot: 'navigationIcon'|'actionItems', path: string, label: string, icon: string | undefined) {
    return html`
      <a href="${path}" slot="${slot}">
        <span>${label}</span>
        <mwc-icon>${icon}</mwc-icon>
      </a>
    `;
  }

  render() {
    return html`
      <mwc-top-app-bar-fixed class="${styles.header}" centerTitle>
        <svg id={style.headerLogo} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 625.1 131.6" slot="title">
          <path d="M27.3 62.8l-6.7 2.8c-1.3.5-2.8-.2-3.3-1.5-2.9-8.9-2-18.6 2.6-26.8.7-1.2 2.3-1.7 3.5-.9l6 4c1 .7 1.4 2 .8 3.1-2.7 5.1-3.2 11-1.6 16.4.4 1.1-.2 2.4-1.3 2.9z"
            fill="#ffca70"
          />
          <path d="M42.4 91.4c-9-2.6-16.6-8.8-20.8-17.1a2.5 2.5 0 0 1 1.2-3.4l6.7-2.8c1.1-.5 2.5 0 3.1 1.1a22 22 0 0 0 12.7 10.5c1.2.4 1.9 1.6 1.6 2.8l-1.4 7.1a2.5 2.5 0 0 1-3.1 1.8z"
            fill="#fedba0"
          />
          <path d="M87.5 38.3l-6.7 2.8c-1.1.5-2.5 0-3.1-1.1A22 22 0 0 0 65 29.5a2.4 2.4 0 0 1-1.6-2.8l1.4-7.1a2.6 2.6 0 0 1 3.1-1.9c9 2.6 16.6 8.8 20.8 17.1.7 1.4.1 3-1.2 3.5z"
            fill="#f9a41b"
          />
          <path d="M57.7 25.7a2.3 2.3 0 0 1-2.6 1.9 21 21 0 0 0-10.5 1.6 21.5 21.5 0 0 0-8.5 6.3c-.8 1-2.2 1.1-3.2.5l-6-4a2.5 2.5 0 0 1-.6-3.5 33.4 33.4 0 0 1 30.8-12.7c1.4.2 2.4 1.5 2.1 2.9l-1.5 7z"
            fill="#fdb740"
          />
          <path class="${styles.st4}" d="M60.6 54.5c0-.8.7-1.6 1.6-1.6h10c.8 0 1.6.7 1.6 1.6v55.1c0 .8-.7 1.6-1.6 1.6h-10c-.8 0-1.6-.7-1.6-1.6V54.5zM93.8 53.4c.1-.7.8-1.3 1.5-1.3h1.3c.4 0 1.2.3 1.4.8l19.3 35.9h.2l19.3-35.9c.2-.5 1-.8 1.4-.8h1.3c.7 0 1.4.6 1.5 1.3l9.4 55.9c.2 1.1-.6 1.8-1.6 1.8H139c-.7 0-1.5-.7-1.6-1.3l-3.7-25.7h-.2l-14 26.9c-.2.5-1 .9-1.4.9h-1.5c-.5 0-1.2-.4-1.4-.9l-14.1-26.9h-.1l-3.7 25.7c-.1.7-.7 1.3-1.6 1.3h-9.8c-1 0-1.7-.7-1.6-1.8l9.5-55.9zM153.6 109l26-56c.2-.5.8-.9 1.4-.9h.8c.6 0 1.2.4 1.4.9l26 56c.5 1.1-.2 2.2-1.4 2.2h-9.2c-1.5 0-2.2-.5-2.9-2.1l-3-6.6h-22.6l-3 6.7a3 3 0 0 1-3 2H155c-1.3 0-1.9-1.1-1.4-2.2zm34.1-17.8l-6.3-13.7h-.1l-6.2 13.7h12.6zM241.3 52.2c7 0 14.6 2.9 20.3 7.8.7.6.8 1.6.2 2.2l-6.6 7c-.7.6-1.6.6-2.2.1-3.2-2.9-6.8-4-10.9-4a16.7 16.7 0 0 0 .1 33.4c2.4 0 4.9-.3 7.4-1.3v-4.8h-5.2c-.9 0-1.6-.7-1.6-1.5v-8.2c0-.9.7-1.6 1.6-1.6H261c.8 0 1.5.7 1.5 1.6l.1 22.4c0 .4-.3 1.1-.7 1.3 0 0-8.6 5.4-20.6 5.4a29.9 29.9 0 1 1 0-59.8zM274 54.5c0-.8.7-1.6 1.6-1.6H310c.9 0 1.6.7 1.6 1.6v9.1c0 .8-.7 1.6-1.6 1.6h-23v10.3h19c.8 0 1.6.7 1.6 1.6v9.1c0 .9-.7 1.6-1.6 1.6h-19V99h23c.9 0 1.6.7 1.6 1.6v9.1c0 .8-.7 1.6-1.6 1.6h-34.4c-.9 0-1.6-.7-1.6-1.6V54.5zM330.6 53.3c.2-.7.8-1.2 1.5-1.2h1.3c.6 0 1.2.4 1.4.9l16.5 45.8h.4L368 53c.2-.5.8-.9 1.4-.9h1.3c.7 0 1.3.5 1.5 1.2l10.7 55.9c.2 1.2-.2 2-1.5 2h-3.3c-.7 0-1.3-.6-1.5-1.2l-7.4-42.8h-.3l-15.3 43.9c-.2.5-.9.9-1.4.9h-1.5c-.5 0-1.2-.4-1.4-.9l-15.5-43.9h-.3l-7.2 42.8c-.1.6-.8 1.2-1.5 1.2h-3.3c-1.2 0-1.7-.8-1.5-2l10.6-55.9zM421.4 52.1a29.9 29.9 0 0 1 29.9 30c0 16.6-13.3 29.9-29.9 29.9s-29.9-13.2-29.9-29.9c0-16.6 13.2-30 29.9-30zm0 54.1c13.2 0 24.1-10.8 24.1-24S434.6 58 421.4 58a24 24 0 1 0 0 48.2zM455.8 55.1c-.5-1.1.2-2.2 1.4-2.2h3.3c.7 0 1.2.5 1.4.9l20.7 46.6h.3l20.7-46.6c.2-.4.7-.9 1.4-.9h3.3c1.2 0 1.9 1.1 1.4 2.2l-25.3 56c-.2.5-.7.9-1.4.9h-.8c-.6 0-1.2-.4-1.4-.9l-25-56zM518.9 54.5c0-.8.7-1.6 1.6-1.6h32.8c.9 0 1.6.7 1.6 1.6v2.4c0 .8-.7 1.6-1.6 1.6h-27.9v20.3h23.9c.8 0 1.6.7 1.6 1.6v2.4c0 .9-.7 1.6-1.6 1.6h-23.9v21.2h27.9c.9 0 1.6.7 1.6 1.6v2.4c0 .8-.7 1.6-1.6 1.6h-32.8c-.9 0-1.6-.7-1.6-1.6V54.5zM568.2 54.5c0-.8.7-1.6 1.6-1.6h21.5c10 0 18.1 7.8 18.1 17.7 0 7.7-5.1 14.1-12.3 17l11.4 21.1c.6 1.1 0 2.4-1.4 2.4h-4.2c-.7 0-1.2-.4-1.3-.7l-11.1-22h-15.9v21.2c0 .8-.7 1.6-1.6 1.6h-3.2c-.9 0-1.6-.7-1.6-1.6V54.5zm22.7 28.4c6.4 0 12-5.3 12-12.1 0-6.3-5.6-11.7-12-11.7h-16.1V83h16.1z" />
        </svg>

        ${this.createNavLink('actionItems', '/help', 'Help', 'help')}

        ${routes.filter((route) => route.render)
          .map((route) => this.createNavLink('navigationIcon', route.path, route.label, route.icon))}
      </mwc-top-app-bar-fixed>
    `;
  }
}

customElements.define(tag, HeaderElement);

export {
  HeaderElement,
  tag
};
